import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart as filledHeart, faHeart as outlineHeart } from '@fortawesome/free-solid-svg-icons'
import { useCustomLiveShoppingContext } from './CustomLiveShoppingContext'
import { useControlBarAccessHooks, useReceiveLike, useSendLike } from 'livekit/livekitHooks'

const LikeButton = ({ participantSid }: { participantSid: string }) => {
  const { likedParticipants, addLikedParticipant, removeLikedParticipant, isLikedParticipant, setLikedParticipants } =
    useCustomLiveShoppingContext()

  const [liked, setLiked] = useState(isLikedParticipant(participantSid))
  const { sendLikeToAll } = useSendLike()
  const { likedParticipants: receivedLikes } = useReceiveLike()
  const { isHostOrCoHostAvailableRoom } = useControlBarAccessHooks()

  const toggleLike = () => {
    if (liked) {
      removeLikedParticipant(participantSid)
      sendLikeToAll(false)
    } else {
      addLikedParticipant([participantSid])
      sendLikeToAll(true)
    }
    setLiked((prev) => !prev)
  }

  useEffect(() => {
    setLikedParticipants(receivedLikes)
  }, [receivedLikes, setLikedParticipants])

  return (
    <div className="relative">
      <button
        className={`flex items-center justify-center rounded-full border ${
          liked ? 'bg-red-100' : 'bg-gray-300'
        } w-10 h-10 ${isHostOrCoHostAvailableRoom ? 'cursor-not-allowed opacity-50' : ''}`}
        aria-label={liked ? 'Unlike' : 'Like'}
        onClick={!isHostOrCoHostAvailableRoom ? toggleLike : undefined}
      >
        <FontAwesomeIcon
          icon={liked ? filledHeart : outlineHeart}
          className={liked ? 'text-red-500' : 'text-gray-500'}
        />
      </button>

      <div className="absolute -top-2 -right-2 flex items-center justify-center p-1 bg-gray-800 text-white text-xs rounded-full w-5 h-5">
        {likedParticipants.length}
      </div>
    </div>
  )
}

export default LikeButton
